/**
 * Directive for drawing the Alert component
 */
define(function (require, exports) {
    'use strict';

    exports.metAlert = function () {
        return {
            restrict: 'E',
            scope: {
                alertType: '@type', // The type of the modal element, Bootstrap style: warning (default), success, info, danger; String, Required
                dismissable: '@' // To show the dismiss button
            },
            replace: true,
            transclude: true,
            template: '<div class="met-alert alert alert-{{alertType}}" role="alert">' +
            '   <button ng-show="{{dismissable}}" type="button" class="close" data-dismiss="alert" aria-label="Close">' +
            '       <span aria-hidden="true">&times;</span>' +
            '   </button>' +
            '   <div ng-transclude></div>' +
            '</div>'
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/metAlert.js